/** Chief Keef operator (bang bang) */
export function exists<T>(t: T): boolean {
  return !!t;
}

/** If and only if */
export function iff<T, U>(a: T, b: U): U | undefined {
  return a ? b : undefined;
}
